// extracted by mini-css-extract-plugin
export default {"suggestionContainer":"mailchecked-input-module__suggestionContainer__wTbma","suggestionButton":"mailchecked-input-module__suggestionButton__dgQD4"};